import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://lgvod.swankmp.net/services/s3services'
})

export default instance